/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Seasonality rules applied to temperature handling.
 * @export
 * @interface ShipmentLimitsTemperatureHandling
 */
export interface ShipmentLimitsTemperatureHandling {
    /**
     * 1-indexed months in which ProtectFromFreezing is not supported.
     * @type {Array<number>}
     * @memberof ShipmentLimitsTemperatureHandling
     */
    protectFromFreezingDisallowedMonths: Array<number>;
}

/**
 * Check if a given object implements the ShipmentLimitsTemperatureHandling interface.
 */
export function instanceOfShipmentLimitsTemperatureHandling(value: object): value is ShipmentLimitsTemperatureHandling {
    if (!('protectFromFreezingDisallowedMonths' in value) || value['protectFromFreezingDisallowedMonths'] === undefined) return false;
    return true;
}

export function ShipmentLimitsTemperatureHandlingFromJSON(json: any): ShipmentLimitsTemperatureHandling {
    return ShipmentLimitsTemperatureHandlingFromJSONTyped(json, false);
}

export function ShipmentLimitsTemperatureHandlingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimitsTemperatureHandling {
    if (json == null) {
        return json;
    }
    return {
        
        'protectFromFreezingDisallowedMonths': json['protectFromFreezingDisallowedMonths'],
    };
}

  export function ShipmentLimitsTemperatureHandlingToJSON(json: any): ShipmentLimitsTemperatureHandling {
      return ShipmentLimitsTemperatureHandlingToJSONTyped(json, false);
  }

  export function ShipmentLimitsTemperatureHandlingToJSONTyped(value?: ShipmentLimitsTemperatureHandling | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'protectFromFreezingDisallowedMonths': value['protectFromFreezingDisallowedMonths'],
    };
}

